import { c as _c } from "react/compiler-runtime";
import * as Popover from '@radix-ui/react-popover';
import { Command } from 'cmdk';
type ComboContentProps = {
  children: React.ReactNode;
  maxWidth?: string;
  maxHeight?: string;
  width?: string;
  align?: 'start' | 'center' | 'end';
};
const ComboContent = t0 => {
  const $ = _c(10);
  const {
    children,
    maxWidth: t1,
    maxHeight: t2,
    width,
    align
  } = t0;
  const maxWidth = t1 === undefined ? "360px" : t1;
  const maxHeight = t2 === undefined ? "360px" : t2;
  let t3;
  if ($[0] !== maxHeight || $[1] !== maxWidth || $[2] !== width) {
    t3 = {
      width,
      maxWidth,
      maxHeight
    };
    $[0] = maxHeight;
    $[1] = maxWidth;
    $[2] = width;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== children) {
    t4 = <Command>{children}</Command>;
    $[4] = children;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== align || $[7] !== t3 || $[8] !== t4) {
    t5 = <Popover.Content className="fp-combo-content" style={t3} sideOffset={8} align={align}>{t4}</Popover.Content>;
    $[6] = align;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
};
export default ComboContent;